import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";
import { TOPICS_QUERY_KEY } from "@circle-react/components/Spaces/TopicFilters/hooks/useTopics";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { PaginationHelper } from "@circle-react/types";
import type { Topic } from "@circle-react/types/Topic";

interface UseTopicsProps {
  ids?: number[];
  query?: string;
  queryOptions?: UseQueryOptions<PaginationHelper<Topic>>;
  spaceId?: string;
}

export const useTopics = ({
  spaceId,
  ids,
  query,
  queryOptions,
}: UseTopicsProps) =>
  useQuery<PaginationHelper<Topic>>({
    queryKey: spaceId
      ? [TOPICS_QUERY_KEY, spaceId, ids, query]
      : [TOPICS_QUERY_KEY, ids, query],
    queryFn: () =>
      reactQueryGet(
        spaceId
          ? internalApi.topics.spaceTopics({
              spaceId,
              params: {
                ...(ids && ids.length > 0 && { ids }),
                ...(query && { query }),
              },
            })
          : internalApi.settings.topics.index({
              params: {
                per_page: 100,
                ...(ids && ids.length > 0 && { ids }),
                ...(query && { query }),
              },
            }),
      ),
    ...queryOptions,
  });
